import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import { keyEmptyCheck } from 'aurora-utils/utils';

import CloseLightIcon from 'aurora-images/close_light.svg';

import styles from './styles';

function RemoveProperty(props) {
  const { onClose, open, removeProperty, classes, unitRegNum, buildingCount } = props;

  return (
    <Dialog onClose={onClose} open={open} classes={{ paper: classes.dialogWrapper }}>
      <DialogTitle className={classes.dialogTitle}>
        {keyEmptyCheck('remove_property')}
        <Button onClick={onClose} className={classes.closeBtn}>
          <img src={CloseLightIcon} alt='Close Light Icon' />
        </Button>
      </DialogTitle>
      <div style={{ padding: '10px' }} className={classes.dialogDetails}>
        <Typography variant='subtitle1' component='div'>
          {buildingCount === 1 && keyEmptyCheck('are_you_sure_you_want_to_remove_property', { s: unitRegNum })}
          {buildingCount > 1 && keyEmptyCheck('are_you_sure_want_to_remove_building', { s: unitRegNum })}
        </Typography>
        <Box className={classes.dialogActions}>
          <Button onClick={onClose} variant='outlined' className={classes.dialogActionBtn}>
            {keyEmptyCheck('discard')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            className={classes.dialogActionBtn}
            onClick={() => {
              onClose();
              removeProperty();
            }}
          >
            {keyEmptyCheck('remove')}
          </Button>
        </Box>
      </div>
    </Dialog>
  );
}

RemoveProperty.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  removeProperty: PropTypes.func.isRequired,
  unitRegNum: PropTypes.func.isRequired,
  buildingCount: PropTypes.number.isRequired,
};
export default withStyles(styles)(RemoveProperty);
